// Dashboard Card IDs
export const DASHBOARD_CARD_IDS = {
  newTalentsClients: "newTalentsClients",
  summary: "summary",
  moreStats: "moreStats",
  jobs: "jobs",
  surveyAnswer: "surveyAnswer",
  talents: "talents",
  clients: "clients",
  adminUsers: "adminUsers",
  newestProjects: "newestProjects",
  financeActivities: "financeActivities",
} as const;

export const DASHBOARD_CARD_LABELS: Record<string, string> = {
  [DASHBOARD_CARD_IDS.newTalentsClients]: "New Talents & Clients",
  [DASHBOARD_CARD_IDS.summary]: "Summary",
  [DASHBOARD_CARD_IDS.moreStats]: "More Stats",
  [DASHBOARD_CARD_IDS.jobs]: "Jobs",
  [DASHBOARD_CARD_IDS.surveyAnswer]: "How do people know Workz360?",
  [DASHBOARD_CARD_IDS.talents]: "Talents",
  [DASHBOARD_CARD_IDS.clients]: "Clients",
  [DASHBOARD_CARD_IDS.adminUsers]: "Admin Users",
  [DASHBOARD_CARD_IDS.newestProjects]: "Newest Projects",
  [DASHBOARD_CARD_IDS.financeActivities]: "Finance Activities",
};

// Default order for dashboard (matching the original layout order)
export const DEFAULT_DASHBOARD_CARD_ORDER = [
  DASHBOARD_CARD_IDS.newTalentsClients,
  DASHBOARD_CARD_IDS.summary,
  DASHBOARD_CARD_IDS.moreStats,
  DASHBOARD_CARD_IDS.jobs,
  DASHBOARD_CARD_IDS.surveyAnswer,
  DASHBOARD_CARD_IDS.talents,
  DASHBOARD_CARD_IDS.clients,
  DASHBOARD_CARD_IDS.adminUsers,
  DASHBOARD_CARD_IDS.newestProjects,
  DASHBOARD_CARD_IDS.financeActivities,
];

export const JOB_COUNT_CARD_IDS = {
  openJobs: "openJobs",
  scheduled: "scheduled",
  inProgress: "inProgress",
  completed: "completed",
  canceled: "canceled",
} as const;

export const JOB_COUNT_CARD_LABELS: Record<string, string> = {
  [JOB_COUNT_CARD_IDS.openJobs]: "Open Jobs",
  [JOB_COUNT_CARD_IDS.scheduled]: "Scheduled",
  [JOB_COUNT_CARD_IDS.inProgress]: "In-Progress",
  [JOB_COUNT_CARD_IDS.completed]: "Completed",
  [JOB_COUNT_CARD_IDS.canceled]: "Canceled",
};

export const DEFAULT_JOB_COUNT_ORDER = [
  JOB_COUNT_CARD_IDS.openJobs,
  JOB_COUNT_CARD_IDS.scheduled,
  JOB_COUNT_CARD_IDS.inProgress,
  JOB_COUNT_CARD_IDS.completed,
  JOB_COUNT_CARD_IDS.canceled,
];
